import { useEffect } from "react";
import { RECEIVE_IDEAS, SEND_IDEAS, Display } from ".";
import { subscribeToolkitReduxDispatches } from "src/state/toolkitReduxStore";
import { toolkitIdeasActions } from "./toolkitIdeasStore";

export function useToolkitIdeasRuntime() {
  useEffect(() => {
    const unsubscribe = subscribeToolkitReduxDispatches((action) => {
      if (action.type !== SEND_IDEAS && action.type !== RECEIVE_IDEAS) {
        return;
      }

      toolkitIdeasActions.mergeDisplay((action.payload ?? {}) as Partial<Display>);
    });

    return () => {
      unsubscribe();
    };
  }, []);
}
